import { Navigate, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import PasswordInput from "components/Custom/Forms/Inputs/PasswordInput";
import authApi from "services/apis/authApi";
import ROUTES from "routes/constant";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const onResetPassword = async (values, actions) => {
    try {
      await authApi.resetPassword({
        emailId: location?.state?.username,
        otp: location?.state?.otp,
        newPassword: values.password,
      });

      toast.success("Password has been reset!!");

      navigate("/");
    } catch (error) {
      /* empty */
    }

    actions.setSubmitting(false);
  };

  const passwordSchema = Yup.object({
    password: Yup.string()
      .label("Password")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Password should be at least 8 characters long with at least one lower case letter,upper case letter, digit and special character."
      )
      .required(),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .label("Re-enter Password")
      .required(),
  });

  if (!location?.state?.username) {
    return <Navigate to="/" replace />;
  }
  return (
    <>
      <div className="form-container text-center">
        <div className="heading">
          <h5>Reset password.</h5>
        </div>
      </div>
      <div className="text-start">
        <Formik
          initialValues={{
            password: "",
            confirmPassword: "",
          }}
          validationSchema={passwordSchema}
          onSubmit={onResetPassword}
        >
          {({ handleSubmit, isValid, isSubmitting }) => (
            <Form className="my-4" onSubmit={handleSubmit}>
              <Field
                id="password"
                type="password"
                name="password"
                label="New Password"
                component={PasswordInput}
                className="form-control"
              />

              <Field
                id="confirmPassword"
                type="confirmPassword"
                name="confirmPassword"
                label="Re-enter Password"
                component={PasswordInput}
                className="form-control"
              />

              <Button
                type="submit"
                className="btn ripple btn-main-primary btn-block mb-2 text-uppercase"
                disabled={!isValid || isSubmitting}
              >
                SUBMIT
              </Button>

              <div className="form-group text-center">
                <NavLink to={ROUTES.AUTH.LOGIN}>
                  Back to <b>Log-in</b>
                </NavLink>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default ResetPassword;
